import './Contact.css'
import { FaLinkedin, FaPhone } from 'react-icons/fa'
import { BsGithub } from 'react-icons/bs'
import { MdEmail } from 'react-icons/md'
import { logContactClick } from '../../supabaseTracker'

const contactLinks = [
  {
    href: 'https://www.linkedin.com/in/m-aqib-nawab/',
    label: 'linkedin',
    icon: FaLinkedin,
  },
  {
    href: 'https://github.com/AQIB-NAWAB',
    label: 'github',
    icon: BsGithub,
  },
  {
    href: 'mailto:aqibnawab1100@gmail.com',
    label: 'email',
    icon: MdEmail,
  },
  {
    href: 'tel:+923084556535',
    label: 'phone',
    icon: FaPhone,
  },
]

function Contact() {
  return (
    <section className='section contact center' id='contact'>
      <h2 className='section__title contact__title'>
        GET IN <span className='about_contact'>TOUCH</span>
      </h2>

      <div className='contact__container'>
        {contactLinks.map(({ href, label, icon: Icon }) => (
          <a
            key={label}
            href={href}
            target={href.startsWith('http') ? '_blank' : undefined}
            rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
            aria-label={label}
            className='contact__link'
            onClick={() => logContactClick(label, 'contact').catch(() => {})}
          >
            <Icon className='contact__icon' />
          </a>
        ))}
      </div>
    </section>
  )
}

export default Contact
